import { useQuery } from '@tanstack/react-query';
import toursApi from '@/features/dashboard/tours/api/toursApi.ts';
import { toursApiQueryKeys } from '@/features/dashboard/tours/api/toursApi.queryKeys.ts';
import { TourStatus } from '@/features/dashboard/tours/types/TourStatus.ts';

const useGetActivationReadiness = (tourId: string, status: TourStatus) => {
  return useQuery({
    queryKey: toursApiQueryKeys.activationReadiness(tourId),
    queryFn: () => toursApi.getActivationReadiness(tourId),
    enabled: status === TourStatus.DRAFT,
  });
};

export default useGetActivationReadiness;
